module.exports = __webpack_public_path__ + "static/img/icon-users.a48e605.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-users.svg
// module id = ZUxY
// module chunks = 28